import { render, staticRenderFns } from "./LabelModal3a1.vue?vue&type=template&id=7322e706&scoped=true&"
import script from "./LabelModal3a1.vue?vue&type=script&lang=js&"
export * from "./LabelModal3a1.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal3a1.vue?vue&type=style&index=0&id=7322e706&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal3a1.vue?vue&type=style&index=1&id=7322e706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7322e706",
  null
  
)

export default component.exports